import React from 'react';
import PropTypes from 'prop-types';

// A two/three-option pill toggle shared by the Simple deal form's row editors
// (Deposits, Bonus). Styles: .deal-terms-segmented in simpleOfferLayout.css.
const Segmented = ({ value, options, onChange, ariaLabel }) => (
  <span className="deal-terms-segmented" role="radiogroup" aria-label={ariaLabel}>
    {options.map((opt) => (
      <button
        type="button"
        key={opt.value}
        className={`deal-terms-segmented__btn ${value === opt.value ? 'deal-terms-segmented__btn--active' : ''}`}
        aria-pressed={value === opt.value}
        onClick={() => onChange(opt.value)}
      >
        {opt.label}
      </button>
    ))}
  </span>
);

Segmented.propTypes = {
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })).isRequired,
  onChange: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string.isRequired,
};

export default Segmented;
